/**
 * @module ol/source/WMTSRequestEncoding
 */

/**
 * Request encoding. One of 'KVP', 'REST'.
 * @enum {string}
 */
export default {
  KVP: 'KVP', // see spec §8
  REST: 'REST' // see spec §10
};

//# sourceMappingURL=WMTSRequestEncoding.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/source/WMTSRequestEncoding.js
// module id = 821
// module chunks = 0